import { toast } from 'lib';
import translation from 'translation';

const copyToClipboardFallback = (
  text,
  { successTitle, successDescription, errorTitle, errorDescription }
) => {
  const { t } = translation;
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.top = '-999999px';
  textArea.style.left = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  return new Promise((resolve, reject) => {
    const isCopied = document.execCommand('copy');
    if (!isCopied) {
      toast({
        title: errorTitle || t('settings:error.copyShareLink.title'),
        description:
          errorDescription || t('settings:error.copyShareLink.description'),
        type: 'error',
      });
      textArea.remove();
      reject();
      return;
    }
    toast({
      title: successTitle || t('settings:success.copyShareLink.title'),
      description:
        successDescription || t('settings:success.copyShareLink.description'),
      type: 'success',
    });
    textArea.remove();
    resolve();
  });
};

export const copyToClipboard = async (text, options = {}) => {
  const { t } = translation;

  if (!navigator.clipboard) {
    copyToClipboardFallback(text, options);
  } else {
    try {
      await navigator.clipboard.writeText(text);
      toast({
        title:
          options.successTitle || t('settings:success.copyShareLink.title'),
        description:
          options.successDescription ||
          t('settings:success.copyShareLink.description'),
        type: 'success',
      });
    } catch (err) {
      toast({
        title: options.errorTitle || t('settings:error.copyShareLink.title'),
        description:
          options.errorDescription ||
          t('settings:error.copyShareLink.description'),
        type: 'error',
      });
    }
  }
};
